// extracted by mini-css-extract-plugin
export default {"hero":"LayeredCardHero_hero__GgTXJ","card":"LayeredCardHero_card__rH-UQ","ufo":"LayeredCardHero_ufo__Pt4-n","platform":"LayeredCardHero_platform__19y8I"};